import { DashboardConfiguration } from '../../../domain';
import { DashboardStoreImpl } from './dashboardStoreImpl';

export function createDashboardStore(dashboard: Partial<DashboardConfiguration> = {}) {
    return new DashboardStoreImpl({
        initialValues: {},
    });
}
